import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'
import { isFarmi } from '@b2ag/app-brands'
import { useFeatureFlipping } from '@b2ag/feature-flipping'
import { getAppContext } from '@b2ag/micro-front-tools'
import { PAGE_TYPE, PAGE_ANALYTICS_INFO } from '../page-types'

const { isFrontAgri } = getAppContext()

/* ------- PARENT - CORE - AGRI ------- */

const VHome = () => import('@b2ag/marketing/src/application/views/VHome/VHome.vue')
const VSearch = () => import('@b2ag/search/src/views/VSearch.vue')
const VProduct = () => import('@b2ag/product/src/views/VProduct.vue')

const coreRoutesAgri = [
  {
    path: '/produits/:productSlug',
    name: 'productOld',
    component: VProduct,
    meta: {
      analyticsPageType: PAGE_TYPE.PRODUCT_PAGE,
      disabledLayoutAlternate: true,
    },
  },
  {
    path: '/p/:productSlug',
    name: 'product',
    component: VProduct,
    meta: {
      analyticsPageType: PAGE_TYPE.PRODUCT_PAGE,
      disabledLayoutAlternate: true,
    },
  },
  {
    path: '/recherche',
    name: 'search',
    component: VSearch,
    meta: {
      analyticsPageType: PAGE_TYPE.SEARCH_RESULT,
    },
  },
  {
    path: '/category/:slug',
    name: 'category',
    component: VSearch,
    props: (route) => {
      return { categorySlug: route.params?.slug || 'undefined' }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.SEARCH_RESULT,
      disabledLayoutAlternate: true,
    },
  },
  {
    path: '/',
    name: 'home',
    component: VHome,
    beforeEnter(_, __, next) {
      const { isPortalEntriesEnabled } = useFeatureFlipping()

      if (isPortalEntriesEnabled.value && !isWebViewFarmi()) {
        next({ name: 'portal-home' })
      } else if (isFarmi && isWebViewFarmi()) {
        next({ name: 'farmi-app-appro-categories' })
      } else {
        next()
      }
    },
    meta: {
      analyticsPageType: PAGE_TYPE.HOME,
    },
  },
]

/* ------- PARENT - CORE - TECH ------- */

const VAppSearch = () => import('@b2ag/search/src/views/VAppSearch.vue')
const VProductMembership = () => import('@b2ag/product/src/views/VProductMembership.vue')

const coreRoutesTech = [
  {
    path: '/',
    name: 'home',
    component: () => import('@b2ag/micro-front-dashboard-tech/app'),
    props: () => {
      return {
        microFrontName: 'dashboard-tech',
        viewName: 'home',
        analyticService: (() => useAnalyticService())(),
      }
    },
    beforeEnter(_, __, next) {
      if (isFarmi && isWebViewFarmi()) {
        next({ name: 'search' })
      } else {
        next()
      }
    },

    meta: {
      isSearchPage: false,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      showWelcomeHeader: true,
      showAppFooter: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.HOME,
      private: true,
    },
  },
  {
    path: '/recherche',
    name: 'search',
    component: VAppSearch,
    meta: {
      isSearchPage: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.SEARCH_RESULTS,
    },
  },
  {
    path: '/category/:slug',
    name: 'category',
    component: VAppSearch,
    props: (route) => {
      return { categorySlug: route.params?.slug || 'undefined' }
    },
    meta: {
      isSearchPage: true,
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.SEARCH_RESULTS,
    },
  },
  {
    path: '/produits/:productSlug',
    name: 'productOld',
    component: VProductMembership,
    meta: {
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.PRODUCT_PAGE,
      disabledLayoutAlternate: true,
    },
  },
  {
    path: '/p/:productSlug',
    name: 'product',
    component: VProductMembership,
    meta: {
      showSelectedCustomer: true,
      changeSelectedCustomer: true,
      analyticsPageInfo: PAGE_ANALYTICS_INFO.PRODUCT_PAGE,
      disabledLayoutAlternate: true,
    },
  },
]

/* ------- PARENT - CORE - Choice ------- */

export const coreRoutes = isFrontAgri ? coreRoutesAgri : coreRoutesTech
